import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane
} from 'reactstrap';
import classnames from "classnames";
import Flatpickr from "react-flatpickr";

//import images
import progileBg from '../../../assets/images/profile-bg.jpg';
import avatar1 from '../../../assets/images/users/avatar-1.jpg';
import AuthService from "../login/AuthService";
import ApiService from "../util/ApiService";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
import PersonalDetailsTab from "./PersonalDetailsTab";
import ConfigLayoutPage from "./ConfigLayoutPage";
import DocumentsTab from "./DocumentsTab";
import PrivateTab from "./PrivateTab";
import axios from 'axios';

const Profile = () => {

    const [activeTab, setActiveTab] = useState("1");

    const tabChange = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };


    document.title = "Perfil | Plantão Rápido";
    const [usersAlter, setUsersAlter] = useState([]);
    const [documents, setDocuments] = useState([]);

    const [cpfCnpj, setCpfCnpj] = useState(null);
    const [loadingPage, setLoadingPage] = useState(false); // Controla o estado do LoadingScreen
    const [loadingSave, setLoadingSave] = useState(false); // Controla o estado do LoadingScreen

    const formatCpfCnpj = (value) => {
        let formattedValue = value.replace(/\D/g, '');

        if (formattedValue.length <= 11) {
            formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else if (formattedValue.length <= 14) {
            formattedValue = formattedValue.replace(/(\d{2})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d{1,4})$/, "$1/$2");
        } else {
            formattedValue = formattedValue.replace(/(\d{2})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d{4})(\d{1,2})$/, "$1/$2-$3");
        }

        return formattedValue;
    };

    const handleCpfCnpjChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setCpfCnpj(formatCpfCnpj(value));

        const {name} = e.target;
        setUsersAlter(prevUsers => ({
            ...prevUsers,
            [name]: value
        }));
    };

    useEffect(() => {
        handleMyData();
    }, []);


    const handleSubmit = async () => {
        try {
            setLoadingSave(true);
            const response = await ApiService.send('put', process.env.REACT_APP_URL_API + 'users/update', usersAlter, true);
            AuthService.updateData(usersAlter);

            if (response.code === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: `Dados atualizado com sucesso.`,
                });
            }

        } catch (error) {
           ApiService.handleApiError(error);
        } finally {
            setLoadingSave(false); // Corrigido aqui também
        }
    };


    const handleMyData = async () => {
        try {
            setLoadingPage(true); // Corrigido aqui
            const response = await ApiService.send('get', process.env.REACT_APP_URL_API + 'users/mydata', {}, true);

            const {data} = ApiService.handleApiResponse(response);
            setUsersAlter(data.user);
            setDocuments(data.documents);
            setCpfCnpj(formatCpfCnpj(data?.user?.cpf));
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false); // Corrigido aqui também
        }
    };


    const handleSubmitImage = async (event) => {
        setLoadingPage(true);

        const imageFile = event.target.files[0]; // ← Aqui está o fix
        if (!imageFile) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Nenhuma imagem selecionada.',
            });
            setLoadingPage(false);
            return;
        }

        const formData = new FormData();
        formData.append('imagem', imageFile);

        ApiService.sendArquivo('post', process.env.REACT_APP_URL_API + 'users/image', formData).then((response) => {
            setLoadingPage(false);

            if (response.code === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Imagem salva com sucesso!',
                });

                AuthService.updateImage(response.data.imagem);

                const img = document.getElementById('header-profile-user-perfil');
                if (img) {
                    img.src = response.data.imagem;
                }

                setUsersAlter(prevUsers => ({
                    ...prevUsers,
                    profile_image: response.data.imagem
                }));

                // limpa o input se necessário
                event.target.value = '';
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Erro ao salvar a imagem. Tente novamente mais tarde.',
                });
            }
        }).catch(error => {
            ApiService.handleApiError(error);
        }).finally(() => {
            setLoadingPage(false);
        });
    };

    const handleChange = (event) => {
        const {name, value} = event.target;
        setUsersAlter(prevUsers => ({
            ...prevUsers,
            [name]: value
        }));

        if (name === 'cpf' && value.length > 0) {
            let cpf = value.replace(/\D/g, '');
            setUsersAlter(prevUsers => ({
                ...prevUsers,
                cpf: cpf
            }));
        }


        if (name === 'zipcode' && value.replace(/\D/g, '').length >= 8) {
            let cep = value.replace(/\D/g, '');
            if (cep) {
                axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                    .then((res) => {
                        const endereco = res?.data;

                        if (!endereco || endereco.erro) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'CEP não encontrado',
                                text: 'Verifique se o CEP digitado está correto.',
                            });
                            return;
                        }

                        setUsersAlter(prevUsers => ({
                            ...prevUsers,
                            street: endereco.logradouro,
                            city: endereco.localidade,
                            state: endereco.uf,
                            district: endereco.bairro,
                            id_city: '',
                        }));
                    })
                    .catch((error) => {
                        console.error("Erro de requisição:", error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro ao buscar CEP',
                            text: 'Não foi possível buscar o endereço. Tente novamente mais tarde.',
                        });
                    });
            }
        }
    };


    const requiredFields = [
        "name",
        "zipcode",
        "street",
        "number",
        "district",
        "state",
        "id_city",
        "cpf",
        "phone",
        "ddd",
        "email"
    ];

    const getProfileCompletionPercent = () => {
        if (!usersAlter) return 0;

        const filledFields = requiredFields.filter(field => {
            const value = usersAlter[field];
            return value !== undefined && value !== null && value.toString().trim() !== "";
        }).length;

        return Math.round((filledFields / requiredFields.length) * 100);
    };


    const handleRemoveDocument = (docId) => {
        setDocuments(prev => prev.filter(doc => doc.id !== docId));
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="position-relative mx-n4 mt-n4">
                        <div className="profile-wid-bg profile-setting-img">
                            <img src={progileBg} className="profile-wid-img" alt=""/>
                        </div>
                    </div>
                    <Row>
                        <Col xxl={4}>
                            <Card className="mt-n5">
                                <CardBody className="p-4">
                                    <div className="text-center">
                                        <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                                            {loadingPage ? (
                                                <Skeleton circle height={110} width={110} />
                                            ) : (
                                                <>
                                                    <img
                                                        src={usersAlter?.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                        className="rounded-circle avatar-xl img-thumbnail user-profile-image object-fit-cover"
                                                        alt="user-profile"
                                                        style={{
                                                            width: '150px',
                                                            height: '150px'
                                                        }}
                                                    />
                                                    <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                                                        <Input
                                                            id="profile-img-file-input"
                                                            type="file"
                                                            onChange={handleSubmitImage}
                                                            className="profile-img-file-input"
                                                        />
                                                        <Label
                                                            htmlFor="profile-img-file-input"
                                                            className="profile-photo-edit avatar-xs"
                                                        >
                                                            <span className="avatar-title rounded-circle bg-light text-body">
                                                                <i className="ri-camera-fill"></i>
                                                            </span>
                                                        </Label>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {/* Nome */}
                                        <h5 className="mb-1">
                                            {loadingPage ? <Skeleton width={140} height={20} /> : usersAlter?.name}
                                        </h5>

                                        {/* Email */}
                                        <p className="text-muted mb-0">
                                            {loadingPage ? <Skeleton width={180} height={14} /> : usersAlter?.email}
                                        </p>

                                        {/* Cidade - Estado */}
                                        <p className="text-muted mb-0">
                                            {loadingPage ? (
                                                <Skeleton width={100} height={14} />
                                            ) : (
                                                usersAlter?.city || usersAlter?.state
                                                    ? `${usersAlter?.city || ''}${usersAlter?.state ? ' - ' + usersAlter.state : ''}`
                                                    : 'Cidade não informada'
                                            )}
                                        </p>
                                    </div>
                                </CardBody>
                            </Card>

                            <Card>
                                <CardBody>
                                    <div className="d-flex align-items-center mb-5">
                                        <div className="flex-grow-1">
                                            <h5 className="card-title mb-0">Complete seu perfil</h5>
                                        </div>
                                    </div>
                                    <div className="progress animated-progress custom-progress progress-label">
                                        <div
                                            className={`progress-bar ${
                                                getProfileCompletionPercent() > 70
                                                    ? "bg-primary"
                                                    : getProfileCompletionPercent() > 50
                                                        ? "bg-warning"
                                                        : "bg-danger"
                                            }`}
                                            role="progressbar"
                                            style={{width: `${getProfileCompletionPercent()}%`}}
                                            aria-valuenow={getProfileCompletionPercent()}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        >
                                            <div className="label">{getProfileCompletionPercent()}%</div>
                                        </div>
                                    </div>


                                </CardBody>
                            </Card>

                            <Card>
                                <CardBody>
                                        {/* Título */}
                                        <div className="d-flex align-items-center mb-4">
                                            <div className="flex-grow-1">
                                                <h5 className="card-title mb-0">Dados</h5>
                                            </div>
                                        </div>

                                        {/* E-mail */}
                                        <div className="mb-3 d-flex">
                                            <div className="avatar-xs d-block flex-shrink-0 me-3">
                    <span className="avatar-title rounded-circle fs-16 bg-primary">
                        <i className="ri-mail-fill"></i>
                    </span>
                                            </div>
                                            <div className="flex-grow-1">
                                                {loadingPage ? (
                                                    <Skeleton height={38} width="100%" borderRadius={6} />
                                                ) : (
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="email"
                                                        name="email"
                                                        placeholder="Seu e-mail"
                                                        onChange={handleChange}
                                                        disabled={!!usersAlter.email}
                                                        value={usersAlter.email}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                        {/* WhatsApp */}
                                        <div className="mb-3 d-flex align-items-center">
                                            <div className="avatar-xs d-block flex-shrink-0 me-3">
                    <span className="avatar-title rounded-circle fs-16 bg-success text-white">
                        <i className="ri-whatsapp-fill"></i>
                    </span>
                                            </div>
                                            <div className="d-flex w-100 gap-2">
                                                {loadingPage ? (
                                                    <>
                                                        <Skeleton height={38} width={70} borderRadius={6} />
                                                        <Skeleton height={38} width="100%" borderRadius={6} />
                                                    </>
                                                ) : (
                                                    <>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="ddd"
                                                            name="ddd"
                                                            placeholder="DDD"
                                                            maxLength={2}
                                                            inputMode="numeric"
                                                            onChange={handleChange}
                                                            value={usersAlter.ddd || ''}
                                                            style={{ maxWidth: '70px' }}
                                                        />
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="phone"
                                                            name="phone"
                                                            placeholder="Número WhatsApp"
                                                            onChange={handleChange}
                                                            value={usersAlter.phone || ''}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        {/* CPF/CNPJ */}
                                        <div className="d-flex">
                                            <div className="avatar-xs d-block flex-shrink-0 me-3">
                    <span className="avatar-title rounded-circle fs-16 bg-danger">
                        <i className="ri-file-text-fill"></i>
                    </span>
                                            </div>
                                            <div className="flex-grow-1">
                                                {loadingPage ? (
                                                    <Skeleton height={38} width="100%" borderRadius={6} />
                                                ) : (
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="cpf"
                                                        name="cpf"
                                                        placeholder="CPF/CNPJ"
                                                        onChange={handleCpfCnpjChange}
                                                        disabled={!!cpfCnpj}
                                                        value={cpfCnpj || ''}
                                                        onBlur={handleSubmit}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                </CardBody>
                            </Card>

                        </Col>

                        <Col xxl={8}>
                            <Card className="mt-xxl-n5">

                                <div className="col-md-12">

                                    <div className="profile-menu">
                                        <ul className="nav nav-tabs nav-tabs-solid">
                                            <li className="nav-item">
                                                <a
                                                    className="nav-link active"
                                                    data-bs-toggle="tab"
                                                    href="#per_details_tab"
                                                >
                                                    Dados Pessoais
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    className="nav-link"
                                                    data-bs-toggle="tab"
                                                    href="#doc_tab"
                                                >
                                                    Documentação
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    className="nav-link"
                                                    data-bs-toggle="tab"
                                                    href="#privacy_tab"
                                                >
                                                    Privacidade
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    className="nav-link"
                                                    data-bs-toggle="tab"
                                                    href="#config_layout_page_tab"
                                                >
                                                    Configuração Visual
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="tab-content profile-tab-cont">
                                        <PersonalDetailsTab
                                            loadingPage={loadingPage}
                                            loadingSave={loadingSave}
                                            usersAlter={usersAlter}
                                            handleChange={handleChange}
                                            handleCpfCnpjChange={handleCpfCnpjChange}
                                            handleSubmit={handleSubmit}
                                        />

                                        <ConfigLayoutPage handleSubmitImage={handleSubmitImage}/>

                                        <DocumentsTab documents={documents} onRemoveDocument={handleRemoveDocument}
                                                      reflesh={handleMyData}  loadingPage={loadingPage}  />

                                        <PrivateTab/>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Profile;